@if (data.fieldEntryType && data.fieldEntryType == 'register') {
  <h2>{{ 'event.registration' | translate }}</h2>
  <p>
    @if (canRegister() == true) {
      <span>{{'button.register' | translate}} {{'time.from' | translate | lowercase}} </span>
      <span>{{ data.fieldRegistrationDate?.[0].fieldRegistrationFirstDate | date:'dd.MM.yyyy' }} </span>
      <span>{{'time.to' | translate | lowercase}} {{ data.fieldRegistrationDate?.[0].fieldRegistrationLastDate | date:'dd.MM.yyyy' }}</span>
    }
    @if (canRegister() == 'ended') {
      <span class="error" role="alert">{{'event.registration_ended' | translate}}</span>
    }
    @if (canRegister() == 'not_started') {
      <span class="error" role="alert">{{'event.registration_not_started' | translate}}</span>
    }
    @if (canRegister() == 'full') {
      <span class="error" role="alert">{{'event.registration_full' | translate}}</span>
    }
  </p>
  @if (canRegister() == true) {
    <div class="actions">
      <button htm-button (click)="modal.toggle('register')"
        data-test-id="sidebar-register-toggle-register-modal-button"
      >{{ 'button.register' | translate }}</button>
      <a href="{{ iCalUrl }}{{ pageData.nid }}"
        data-test-id="sidebar-register-calendar-add-link"
      >{{'button.calendar_add' | translate}}</a>
    </div>
  }
  <htm-modal
    id="register"
    modalTitle="{{ 'event.registration_form' | translate }}"
    [bottomAction]="false"
    (onClose)="clearModal()"
    >
    <ng-template id="register">
      @if (!loading && step === 1) {
        <h2 class="eventTitle">{{ pageData.title }}</h2>
        <div class="dialog__time" tabindex="0">
          <span class="capitalize">{{ 'time.'+ (pageData.eventStartDate | weekday: "unix" | lowercase) | translate }} {{ pageData.eventStartDate | date: "dd.MM"}}</span>
          @if (pageData.fieldEventStartTimeMain || pageData.fieldEventEndTimeMain) {
            <span>
              <span> {{ 'time.time_of_day' | translate }}</span>
              @if (pageData.fieldEventStartTimeMain) {
                {{ pageData.fieldEventStartTimeMain | unixToTime  }}
              }
              @if (pageData.fieldEventStartTimeMain && pageData.fieldEventEndTimeMain) {
                -
              }
              @if (pageData.fieldEventEndTimeMain) {
                {{ pageData.fieldEventEndTimeMain | unixToTime  }}
              }
            </span>
          }
          @if (pageData.eventExtraDates && pageData.eventExtraDates.length) {
            @for (item of pageData.eventExtraDates; track item) {
              <div>
                @if (item.fieldEventAdditionalDate) {
                  <span class="capitalize">{{ 'time.'+ (item.fieldEventAdditionalDate | weekday: "unix" | lowercase) | translate }} {{ item.fieldEventAdditionalDate | date: "dd.MM"}}</span>
                  @if (item.fieldEventStartTimeAddition || item.fieldEventEndTimeAddition) {
                    <span>
                      <span> {{ 'time.time_of_day' | translate }}</span>
                      @if (item.fieldEventStartTimeAddition) {
                        {{ item.fieldEventStartTimeAddition | unixToTime  }}
                      }
                      @if (item.fieldEventStartTimeAddition && item.fieldEventEndTimeAddition) {
                        -
                      }
                      @if (item.fieldEventEndTimeAddition) {
                        {{ item.fieldEventEndTimeAddition | unixToTime  }}
                      }
                    </span>
                  }
                }
              </div>
            }
          }
        </div>
        <p>* {{ 'event.registration_form_required' | translate }}</p>
        <form [formGroup]="form" (submit)="submitForm()">
          <div class="row">
            <div class="col-6 md-12 sm-12">
              <formItem type="text" [title]="('event_registration.first_name' | translate) + ' *'" formControlName="firstName" [error]="formSubmitted && hasError('firstName')"
                testId="sidebar-register-first-name-input"
              ></formItem>
            </div><!--/col-6-->
            <div class="col-6 md-12 sm-12">
              <formItem type="text" [title]="('event_registration.last_name' | translate) + ' *'" formControlName="lastName" [error]="formSubmitted && hasError('lastName')"
                testId="sidebar-register-last-name-input"
              ></formItem>
            </div><!--/col-6-->
            <div class="col-12">
              <formItem type="text" [title]="'event_registration.company_name' | translate" formControlName="companyName"
                testId="sidebar-register-company-name-input"
              ></formItem>
            </div><!--/col-12-->
            <div class="col-6 md-12 sm-12">
              <formItem type="text" [title]="('event_registration.email' | translate) + ' *'" formControlName="email" [error]="formSubmitted && hasError('email')"
                testId="sidebar-register-email-input"
              ></formItem>
            </div><!--/col-6-->
            <div class="col-6 md-12 sm-12">
              <formItem type="text" [title]="('event_registration.phone' | translate) + ' *'" formControlName="telephone"
                [error]="formSubmitted && hasError('telephone')"
                testId="sidebar-register-telephone-input"
              ></formItem>
            </div><!--/col-6-->
            <div class="col-12">
              <formItem type="textarea" [title]="'event_registration.marked' | translate" formControlName="marked"
                testId="sidebar-register-marked-input"
              ></formItem>
            </div><!--/col-12-->
          </div><!--/row-->
          <div class="buttons">
            <a htm-button theme="plain" (click)="modal.close('register')"
              data-test-id="sidebar-register-close-register-modal-link">
              {{'event.registration_form_cancel' | translate}}
            </a>
            <button htm-button
              data-test-id="sidebar-register-registration-submit-button"
              >{{'event.registration_form_send' | translate}}
            </button>
          </div><!--/buttons-->
        </form>
      }
      @if (!loading && step == 2) {
        <div class="registerResponse">
          @if (response && response?.errors?.length == 0) {
            <h2>{{ 'event.registration_form_thanks' | translate }}</h2>
          }
          @if (response) {
            @for (item of response?.errors; track item) {
              @if (item == 1) {
                <h2>{{ 'event.registration_full' | translate }}</h2>
              }
            }
          }
          <a htm-button href="{{ iCalUrl }}{{ pageData.nid }}"
            data-test-id="sidebar-register-second-step-calendar-add-link"
          >{{'event.registration_form_add_to_calendar' | translate}}</a>
          <button htm-button theme="plain" (click)="modal.close('register')"
            data-test-id="sidebar-register-second-step-close-register-modal-button"
          >{{ 'event.registration_form_close' | translate }}</button>
        </div><!--/registerResponse-->
      }
      @if (loading) {
        <loader></loader>
      }
    </ng-template>
  </htm-modal>
}

@if (data.fieldEntryType == 'external_inv' || data.fieldEntryType === 'juhan') {
  <h3>{{ 'event.registration' | translate }}</h3>
  @if (data.fieldRegistrationUrl?.length) {
    <div class="actions">
      <a target="_blank" [href]="data.fieldRegistrationUrl[0].uri"
        [attr.data-test-id]="'sidebar-register-action-link-' + (data?.fieldRegistrationUrl?.[0]?.uri | slugify)"
      >{{ 'event.external_registration' | translate }}</a>
    </div>
  }
}

@if (data.fieldEntryType && data.fieldEntryType == 'free' && !data.EventRegistrations) {
  <h3>{{ 'event.entrance' | translate }}</h3>
  <p>
    @if (canRegister() !== 'ended') {
      <span >{{'event.free' | translate}}</span>
    }
    @if (canRegister() == 'ended') {
      <span class="error">{{'event.passed' | translate}}</span>
    }
  </p>
}

@if (data.fieldEntryType && data.fieldEntryType == 'invite') {
  <h3>{{ 'event.registration' | translate }}</h3>
  <p>
    @if (canRegister() !== 'ended') {
      <span>{{'event.invite' | translate}}</span>
    }
    @if (canRegister() == 'ended') {
      <span class="error" >{{'event.passed' | translate}}</span>
    }
  </p>
}

@if (data.EventRegistrations && step === 4) {
  <h3>{{'event.participant_list' | translate}}</h3>
  <div class="actions">
    <button htm-button (click)="toggleParticipants(true)"
      data-test-id="sidebar-register-toggle-participants-button"
    >{{'event.participants_list_view' | translate}}</button>
  </div><!--/actions-->
}
